import React from 'react';
import Navbar from '../components/Navbar';
import DataTable from '../components/DataTable';

/* TO DO:
 * Create table and display all arbiters and standard coders
 */

const AllCodersPage = () => {

  const allCodersColumns = ["Name", "Coder Type", "Active to work"];

  const allCodersData = [
    ["Charlee Sanders", "arbiter", "active"],
    ["Bob Patel", "standard coder", ""],
    ["Evelyn Robert", "standard coder", "active"],
    ["Joel Casey", "arbiter", "active"],
    ["Graysen Richards", "arbiter", "active"],
    ["Ambrose Reid", "standard coder", ""],
    ["Duncan Campos", "standard coder", "active"],
    ["Jolie Gallegos", "arbiter", ""],
    ["Parker Leach", "standard coder", ""],
    ["Neil Frost", "standard coder", ""],
    ["Maren Rosario", "standard coder", "active"],
    ["Jamison Harvey", "standard coder", "active"],
    ["Alivia Herring", "standard coder", "active"],
    ["Apollo Thompson", "standard coder", ""],
    ["River Walls", "standard coder", "active"],
  ];

  /* DataTable component adheres to code re-use by passing in custom parameters
    (columns, data, route, title) when calling the component.
   */

  return (
    <div className="AllCodersPage">
    <Navbar/>
    <DataTable columns={allCodersColumns} data={allCodersData} route={"/profile"} title={"All Coders"}/>
</div>
  );
};

export default AllCodersPage;